import { TenantContext } from '@web/services/TenantContext'
import { useContext } from 'react'
import type { useProvideTenant } from './useProvideTenant'

export const useTenant = () =>
  useContext(TenantContext) as ReturnType<typeof useProvideTenant>
